import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface ServiceGridBlockRendererProps {
  block: { settings: Record<string, any> };
  config: TemplateConfig;
}

interface ServiceItem {
  title: string;
  icon?: string;
}

const ServiceGridBlockRenderer: React.FC<ServiceGridBlockRendererProps> = ({
  block,
  config,
}) => {
  const s = block.settings;
  const rawItems = s.items;
  const items: ServiceItem[] = Array.isArray(rawItems)
    ? rawItems
        .map((it: any): ServiceItem | null => {
          if (!it || typeof it !== 'object') return null;
          const title = String(it.title ?? '');
          if (!title) return null;
          const icon = typeof it.icon === 'string' ? it.icon : undefined;
          return { title, icon };
        })
        .filter((x: ServiceItem | null): x is ServiceItem => x !== null)
    : [];
  const colsRaw = s.columns;
  const columns = colsRaw === 2 || colsRaw === 3 ? colsRaw : 2;
  const accent =
    typeof s.accentColor === 'string' ? s.accentColor : config.aksanRenk;
  const titleSize = config.fontBoyutu;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        gap: 12,
        fontFamily: config.font,
      }}
    >
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            border: '1px solid #e8e8e8',
            borderLeft: `4px solid ${accent}`,
            borderRadius: 8,
            padding: '14px 16px',
            backgroundColor: '#fafafa',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            minHeight: 48,
          }}
        >
          {item.icon ? (
            <span
              style={{
                fontSize: Math.round(titleSize * 1.2),
                lineHeight: 1,
                flexShrink: 0,
              }}
              aria-hidden
            >
              {item.icon}
            </span>
          ) : null}
          <div
            style={{
              fontSize: titleSize,
              fontWeight: 600,
              color: '#1a1a1a',
              lineHeight: 1.35,
            }}
          >
            {item.title}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceGridBlockRenderer;
